module.exports = __webpack_public_path__ + "img/ESG.632ef8f0.svg";